<template>
    <div class="automation-trigger-settings">
        <modal
            ref="enterStage"
            :startsOpen="false"
            id="enterStage"
            @hide="close"
            class="modal-journey"
        >
            <template slot="title"> {{ t('automations-form-triggers_config-enter_stage-modal_title') }} </template>
            <template slot="body">
                <div>
                    <JourneyTree @select="select">
                        <template #actions="{ node: childNode }">
                            <span class="icon">
                                <div
                                    class="far fa"
                                    :class="
                                        selected.includes(childNode.id)
                                            ? 'fa-check-square'
                                            : 'fa-square-o'
                                    "
                                ></div>
                            </span>
                        </template>
                    </JourneyTree>
                </div>
            </template>
            <template slot="footer">
                <div>
                    <button
                        type="button"
                        class="btn btn-cancel"
                        @click.prevent.stop="close"
                    >
                        {{ t('automations-form-triggers_config-enter_stage-close_button') }}
                    </button>
                </div>
            </template>
        </modal>
        <p>
            {{ t('automations-form-triggers_config-enter_stage-description') }}
        </p>

        <button
            @click.prevent.stop="openModal"
            class="btn"
            :class="isValid() ? 'btn-primary' : 'btn-danger'"
        >
            {{ t('automations-form-triggers_config-enter_stage-select_stage_button') }}
        </button>
    </div>
</template>
<style scoped lang="scss">
::v-deep {
    .modal-journey {
        .modal-dialog {
            max-width: 90vw;
            height: 90vh;
        }
        .modal-body {
            height: calc(100vh - 250px);
            max-height: calc(100vh - 250px);
            > div {
                height: 100%;
                > form {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    .automation-action-settings {
                        flex-grow: 1;
                        overflow: auto;
                    }
                }
            }
        }
    }
}
</style>
<script>
import JourneyTree from "../../../clients/journey/tree.vue";

export default {
    components: {
        JourneyTree,
    },
    props: {
        value: Array,
    },
    data: function () {
        let selected =
            this.value.length > 0 && this.value[0].selected
                ? parseInt(this.value[0].selected)
                : [];
        return {
            selected,
        };
    },
    mounted: function () {
        this.changed();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        select(node) {
            if (this.selected.includes(node.id)) {
                this.selected = this.selected.filter((id) => id !== node.id);
            } else {
                this.selected.push(node.id);
            }
            this.changed();
        },
        openModal() {
            this.$refs.enterStage.open();
        },
        close() {
            this.$refs.enterStage.close();
        },
        changed: function () {
            this.$emit("input", [{ selected: this.selected }]);
        },
        isValid: function () {
            return this.selected.length > 0;
        },
    },
    watch: {
        selected: function () {
            this.changed();
        },
        value: function () {
            let selected =
                this.value.length > 0 && this.value[0].selected
                    ? this.value[0].selected
                    : [];
            if (JSON.stringify(selected) !== JSON.stringify(this.selected)) {
                this.selected = selected;
            }
        },
    },
};
</script>
